/* unplugin-vue-components disabled */import { render } from "./imagetransfer.vue?vue&type=template&id=90cc4534&scoped=true"
import script from "./imagetransfer.vue?vue&type=script&lang=js"
export * from "./imagetransfer.vue?vue&type=script&lang=js"

import "./imagetransfer.vue?vue&type=style&index=0&id=90cc4534&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90cc4534"]])

export default __exports__